import AvatarList from '@effectivastudio/lit-components/components/avatar_list/element.js';

AvatarList.config.reverseStack = true;
